import i from 'icepick'
import { filter } from 'lodash'

const initialState = {
  services: [],
  numberRanges: [],
  huntGroups: [],
  users: [],
  autoAttendants: [],
  queues: [],
  telephoneAdapters: [],
  servicesGetLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'PHONE_SYSTEM/GET_PHONE_SYSTEMS_PENDING':
      return i.assoc(state, 'servicesGetLoading', true)
    case 'PHONE_SYSTEM/GET_PHONE_SYSTEMS_REJECTED':
      return i.assoc(state, 'servicesGetLoading', false)
    case 'PHONE_SYSTEM/GET_PHONE_SYSTEMS_FULFILLED':
      return i
        .chain(state)
        .assoc('services', filter(action.payload.data, { serviceType: 'PBX System' }))
        .assoc('numberRanges', filter(action.payload.data, { serviceType: 'Number Range' }))
        .assoc('users', filter(action.payload.data, { serviceType: 'User' }))
        .assoc('huntGroups', filter(action.payload.data, { serviceType: 'Hunt Group' }))
        .assoc('autoAttendants', filter(action.payload.data, { serviceType: 'Auto Attendant' }))
        .assoc('queues', filter(action.payload.data, { serviceType: 'Queue' }))
        .assoc(
          'telephoneAdapters',
          filter(action.payload.data, { serviceType: 'Telephone Adapter' })
        )
        .assoc('servicesGetLoading', false)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PhoneSystem/PhoneSystem.reducer.js